var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
export var Alert = function (_a) {
    var showIcon = _a.showIcon, message = _a.message, _b = _a.level, level = _b === void 0 ? 'danger' : _b, className = _a.className, children = _a.children, props = __rest(_a, ["showIcon", "message", "level", "className", "children"]);
    if ((!message || (Array.isArray(message) && !message.length)) &&
        !children) {
        return null;
    }
    return (_jsxs("div", __assign({ className: classNames('alert', "alert-".concat(level), {
            'd-flex': showIcon,
        }, className), role: "alert" }, props, { children: [showIcon && (_jsx("div", { className: "me-3 d-flex align-items-center", children: _jsx("i", { className: "bi bi-exclamation-triangle-fill" }) })), Array.isArray(message) && message.length > 1 ? (_jsxs(_Fragment, { children: [_jsx("div", { children: "Error:" }), _jsx("ul", { className: "mb-0", children: message.map(function (message) { return (_jsx("li", { children: message }, message)); }) })] })) : (message), children] })));
};
